import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { type IGeoTagsMap, type IUndergroundGeoTag } from '@/microfrontends/filters/shared/types/geoTags';
import { getTagComparator } from '@/microfrontends/filters/shared/utils/geo';

import { type IStationData } from '../../../containers/UndergroundMapModalContainer/internal/types';
import { GEO_TAGS_MAP_DEFAULT } from '../../constants/geoTags';

import { type IGeoTagsState } from './types';

const geoTagsInitialState: IGeoTagsState = {
  status: 'initial',
  data: GEO_TAGS_MAP_DEFAULT,
};

export const geoTagsSlice = createSlice({
  initialState: { ...geoTagsInitialState },
  name: 'geoTags',
  reducers: {
    set: (state, action: PayloadAction<IGeoTagsMap>) => {
      state.data = action.payload;
    },
    add: (state, action: PayloadAction<IGeoTagsMap[keyof IGeoTagsMap]>) => {
      for (const geoTag of action.payload) {
        if (geoTag.type === 'bbox') {
          continue;
        }

        const comparator = getTagComparator(geoTag.type);
        const hasGeoTag = !!state.data[geoTag.type].find(item => comparator(item, geoTag));
        if (!hasGeoTag) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          state.data[geoTag.type].push(geoTag as any);
        }
      }
    },
    addUndergroundTagsIfNotExists: (state, action: PayloadAction<IStationData[]>) => {
      const { underground } = state.data;
      const newUnderground: IUndergroundGeoTag[] = action.payload
        .filter(station => !underground.some(({ id: tagId }) => tagId === station.id))
        .map(({ id, name, color }) => ({
          type: 'underground',
          id,
          name,
          color: color || null,
          releaseYear: null,
          underConstruction: false,
        }));

      state.data.underground = [...underground, ...newUnderground];
    },
  },
});

export const { reducer: geoTagsReducer, actions: geoTagsActions } = geoTagsSlice;
